module.exports = __webpack_public_path__ + "static/media/tip-modal-operations.05f3536c.png";